import Entity from './entity'

export default class Unit extends Entity<number>{
    orderNo:number;
    code:string;
    name:string;
    displayName :string;
    clientCode:string;
    clientName:string;
}